<template>
    <div>
        <!--class="grid with-grid-lines page--light is-chrome"-->
        <encabezado></encabezado>
        <breadcrum :titulo='titulo' :texto='texto'></breadcrum>
        <div style="padding-left:10%">
            <textos-index></textos-index>
            <formulario></formulario>
            <boton-enviar></boton-enviar>
        </div>
        <pie></pie>
    </div>
</template>

<script>
    import encabezado from '@/components/newEncabezado'
    import breadcrum from '@/components/breadcrum'
    import textosIndex from '@/components/textosIndex'
    import formulario from '@/components/formulario'
    import botonEnviar from '@/components/enviarOrden'
    import pie from '@/components/newPie'

    export default {
        name: 'index',
        components: {
            encabezado,
            breadcrum,
            textosIndex,
            formulario,
            botonEnviar,
            pie
        },
        data: () => ({
            texto: '¿Tu dispositivo está dañado? Danos tus datos y enviaremos a alguien a recogerlo, lo repararemos y te lo devolveremos.',
            titulo: "Posventa"
        }),
        created() {
            this.$bus.formulario.company = true
            this.$bus.getCodigosPostales()
        },
    }
</script>